<template>
    <div class="template_container" :style="$parent.styleTemplate($parent.item)">
        <div class="theme-color">
            <button class="btn-theme-font" @click="$parent.$emit('setModal', 'editFontFamily')">
                Font <i class="fas fa-font"></i>
            </button>
            <button class="btn-theme-color" @click="$parent.$emit('setModal', 'editColorTheme')">
                Color <i class="fas fa-paint-brush"></i>
            </button>
        </div>
        <div class="header_about_me">
            <div class="cover_container">
                <div class="cover_picture" :style="$parent.isBackgroundCover($parent.item)">
                    <div class="cover_video" v-if="$parent.item.pictures[0].cover_v_active">
                        <video id="cover_video_player" loop muted="muted" playsinline="true" autoplay :key="'video-'+$parent.item.id"
                        :style="$parent.positionVideo($parent.item)">
                            <source :src="$parent.srcCoverVideo($parent.item)" type='video/mp4; codecs="avc1.42E01E, mp4a.40.2"' />
                        </video>
                    </div>
                    <div class="cover_picture_before"
                        v-if="$parent.item.pictures[0].cover_active"
                        :style="'background-color: rgba(0 0 0 / '+$parent.item.pictures[0].cover_overlay+'%);'"
                    ></div>
                    <div class="edit edit-cover" @click="$parent.$emit('setModal', 'editCover')"><i class="fas fa-pen"></i> Cover</div>
                    <!-- <div class="logo_picture" :style="isLogo(item)"></div> -->
                    <!-- <div class="edit edit-logo" @click="$emit('setModal', 'editLogo')"><i class="fas fa-pen"></i> Edit Logo</div> -->
                </div>
            </div>
            <div class="header_rrss">
                <div class="social-icons">
                    <div :class="['contact-iconos', 'text-center', 'edit-contact']">
                        <div class="box-icon" v-for="c in $parent.item.find_me_at" :key="c.id" v-show="c.status==1">
                            <div class="button-icon hvr-sweep-to-bottom">
                                <a href="#" @click.prevent="$parent.editContact()" :class="'btn btn-sbg '" >
                                    <i :class="c.icon"></i>
                                    <p>{{$parent.helperLabel(c)}}</p>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="profile_picture" :style="$parent.isProfile($parent.item)">
                    <i class="fas fa-image" v-if="$parent.isProfile($parent.item)==''"></i>
                    <Loader v-if="$parent.profileLoad" class="profileLoad"></Loader>
                    <div class="edit edit-profile" @click="$parent.editPicProfile()"><i class="fas fa-pen"></i></div>
                </div>
            </div>
        </div>
        <div class="profile">
            <div class="author-info">
                <div class="edit edit-info" @click="$parent.$emit('setModal', 'editInfo')"><i class="fas fa-pen"></i></div>
                <h1 class="name" ref="fullNameElement" :style="nameStyle">{{fullname}}</h1>
                <p class="rol">{{$parent.item.rol}}</p>
                <!-- <h2 class="company" :style="$parent.item.hide_data=='not' ? 'opacity:0;' : ''">{{$parent.orginf.com_company_name}}</h2> -->
            </div>
            <div class="share_me">
                <a href="#Share_link" @click.prevent="$parent.linkVoid()" class="btn share_link hvr-float" aria-label="Share" >
                    <img :src="$parent.urlweb+'img/share.svg'" style="width: 20px;" alt="icon_share" width="20" height="auto"/>
                </a>
                <a href="#Show_Qr" @click.prevent="$parent.linkVoid()" class="btn show_Qr hvr-float" aria-label="show or Hide code Qr">
                    <img :src="$parent.urlweb+'img/qr_icono.png'" style="width: 20px;" alt="icon_share" width="20" height="20"/>
                </a>
            </div>
        </div>
        <div class="contact_me">
            <div class="edit edit-info" @click="$parent.$emit('setModal', 'editContactMe')"><i class="fas fa-pen"></i></div>
            <ul v-if="$parent.isContactMe($parent.item).valid">
                <template v-for="c in $parent.isContactMe($parent.item).value" >
                    <li v-if="c.status==1 " :key="c.id">
                        <a href="#" @click.prevent="() => { return false; }" :class="'btn btn-sbg '" v-if="c.type!=='about_me'">
                            <i :class="c.type=='call' ? 'fas fa-phone-alt' : c.type=='email' ? 'fas fa-envelope' : c.type=='address' ? 'fas fa-map-marker-alt' : ''"></i>
                            <span v-if="c.type=='call'">{{$parent.modelarNumeroTel(c.value)}}</span>
                            <span v-else :style="c.type=='address' ? 'white-space: pre-line; text-transform: capitalize;' : ''">{{c.value}}</span>
                        </a>
                        <div v-else class="box_about_Me">
                            <div class="ico-info"><i class="fas fa-info-circle"></i></div>
                            <div class="text_box" v-html="c.value"></div>
                        </div>
                    </li>
                </template>
            </ul>
        </div>
        <div class="section-btnsActions">
            <div class="edit edit-btnsActions" @click="$parent.edit_btnsActions()"><i class="fas fa-pen"></i></div>
            <div class="list-btnsActions" v-if="$parent.premiumProfile && $parent.item.btns_action!=null && $parent.item.btns_action.length>0">
                <a href="#" v-if="$parent.btns_action($parent.item.btns_action).length>=1"
                    @click.prevent="$parent.edit_btnsActions()"
                    class="btn-action hvr-shrink btnFirst"
                    :aria-label="$parent.btns_action($parent.item.btns_action)[0].label"
                    :style="customBgBtn($parent.item.btns_action[0].style)"
                >
                    {{$parent.btns_action($parent.item.btns_action)[0].label}}
                </a>
                <a href="#" v-if="$parent.btns_action($parent.item.btns_action).length>=2"
                    @click.prevent="$parent.edit_btnsActions()"
                    class="btn-action hvr-shrink btnSecond"
                    :aria-label="$parent.btns_action($parent.item.btns_action)[1].label"
                    :style="customBgBtn($parent.item.btns_action[1].style)"
                >
                <div class="label-text">
                    {{ $parent.btns_action($parent.item.btns_action)[1].label }}
                </div>
                </a>
                <a href="#" v-if="$parent.btns_action($parent.item.btns_action).length==3"
                    @click.prevent="$parent.edit_btnsActions()"
                    class="btn-action hvr-shrink btnThird"
                    :aria-label="$parent.btns_action($parent.item.btns_action)[2].label"
                    :style="customBgBtn($parent.item.btns_action[2].style)"
                >
                    <span class="label-link">{{$parent.btns_action($parent.item.btns_action)[2].label}}</span>
                </a>
            </div>
            <a v-else href="#" @click.prevent="$parent.edit_btnsActions()" class="btn-blue btn-action hvr-shrink" aria-label="ADD TO CONTACT">
                ADD TO CONTACT
            </a>
        </div>
    </div>
</template>
<script>
export default {
    name:"htmlTemplate7",
    data() {
        return {
            fullname: '',
            fontSizeFullName: 44,
        }
    },
    mounted() {
        this.fullname = this.$parent.item.name + ' ' + this.$parent.item.lastname;
        const initialFont = this.activeFontFamily;
        if (initialFont) {
            this.loadGoogleFont(initialFont);
        }
        this.$nextTick(() => { this.adjustFontSize(); });
    },
    watch: {
        fullname() {
            this.$nextTick(() => { this.adjustFontSize(); });
        },
        activeFontFamily(newFont) {
            if (newFont) {
                this.loadGoogleFont(newFont);
            }
            this.adjustFontSizeAfterFontLoad(newFont);
        },
    },
    computed: {
        activeFontFamily() {
            // @ts-ignore
            const item = this.$parent && this.$parent.item;
            if (!item || !item.temp_opts) return '';
            // @ts-ignore
            const opt = item.temp_opts.find(o =>
                o.meta_key === 'font_family' && Number(o.template_id) === Number(item.template_id)
            );
            return opt ? (opt.meta_value || '') : '';
        },
        nameStyle() {
            return {
                fontSize: this.fontSizeFullName + 'px',
                fontFamily: this.activeFontFamily ? `'${this.activeFontFamily}', sans-serif` : undefined,
            };
        },
    },
    methods: {
        customBgBtn(style){
            let t = this;
            let d = t.$parent.style_default;
            let s = '';
            let css = (style==null || style=='null' || style=='' || style==='[object Object]') ? d : ((typeof style === 'object') ? style : JSON.parse(style));
            if(css!=''){
                s+='background: '+css.bgColor+';';
                s+='border-color: '+css.bgColor+';';
                s+='color: '+css.txtColor+';'
            }
            // console.log('style', s);
            return s;
        },
        adjustFontSize() {
            const el = this.$refs.fullNameElement;
            if (!el || !el.parentElement) return;
            const maxWidth = el.parentElement.offsetWidth;
            let size = 60; // Tamaño inicial grande para asegurar que se reduzca si es necesario
            const safetyGap = 20; // Espacio adicional para evitar que el texto toque los bordes
            const minSize = 25; // Tamaño mínimo para evitar que el texto sea ilegible
            // console.log('adjustFontSize', size, (el.scrollWidth+safetyGap), maxWidth);
            el.style.fontSize = size + 'px';
            while ((el.scrollWidth + safetyGap) > maxWidth && size > minSize) {
                size--;
                // console.log('adjustFontSize', size, (el.scrollWidth+safetyGap), maxWidth);
                el.style.fontSize = size + 'px';
            }
            this.fontSizeFullName = size;
        },
    }
}
</script>
<style lang="scss" scoped>
@import url('../scss/efectsThemes.scss');
@import url('../scss/baseTemplate.scss');
@import url('../scss/card_about_me.scss');
.edit.edit-cover {
    background-color: rgba(0, 0, 0, 0.5);
    opacity: 0.2;
}
.edit.edit-btnsActions {
    width: 100%!important;
}
</style>
